module.exports = __webpack_public_path__ + "images/tour/activity_tagging-bc48cea1f184477a64dffb78410f2d4d.gif";